import React, { createContext, useContext, FC } from "react";
import type { IServices } from "services/IServices";

const ServiceContext = createContext<IServices>(null);

interface IProps {
    Services: IServices;
}

export const ServiceProvider: FC<IProps> = ({ Services, children }) => (
    <ServiceContext.Provider value={Services}>{children}</ServiceContext.Provider>
);

export const useServices = () => useContext(ServiceContext);
